import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { Config, IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { ModalNoneTransition } from '../util/modal-none-transition';

import { MyApp } from './app.component';

import { ConfigApp } from "../providers/config.app";
import { ToastService } from "../services/toast-service";
import { ServerService } from "../services/server-service";
import { ActivityPickerService } from "../services/activity-picker.service";
import { WebPushService } from "../services/web-push.service";
import { AppSettings } from "../services/app-settings";
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from '../pages/login/login';
import { LoginPageModule } from '../pages/login/login.module';
import { ComponentsModule } from '../components/components.module';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpModule } from "@angular/http";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppVersion } from '@ionic-native/app-version';
import { Network } from '@ionic-native/network';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Geolocation } from '@ionic-native/geolocation';
import { Diagnostic } from '@ionic-native/diagnostic';
import { IonicSelectableModule } from 'ionic-selectable';

import { AngularFireModule, FirebaseAppConfigToken, FirebaseAppName } from 'angularfire2';
// import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';

import { File } from '@ionic-native/file';
import { Camera } from "@ionic-native/camera";
import { FilePath } from "@ionic-native/file-path";
import { Transfer } from "@ionic-native/transfer";

import { IonicImageViewerModule } from 'ionic-img-viewer';

import { Ng2GoogleChartsModule } from 'ng2-google-charts';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { OpenNativeSettings } from '@ionic-native/open-native-settings';
import { AndroidPermissions } from '@ionic-native/android-permissions';

import { LocalNotifications } from '@ionic-native/local-notifications';

import { SocialSharing } from '@ionic-native/social-sharing';

import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { Keyboard } from '@ionic-native/keyboard';

export function LanguageLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

/** Named app avoids a broken default app if init runs without config (e.g. lazy-loaded modules). */
export const FIREBASE_APP_NAME = 'mentor';

export const firebaseConfig = {
  apiKey: AppSettings.FIREBASE.apiKey,
  authDomain: AppSettings.FIREBASE.authDomain,
  databaseURL: AppSettings.FIREBASE.databaseURL,
  projectId: AppSettings.FIREBASE.projectId,
  storageBucket: AppSettings.FIREBASE.storageBucket,
  messagingSenderId: AppSettings.FIREBASE.messagingSenderId,
  appId: AppSettings.FIREBASE.appId,
  measurementId: AppSettings.FIREBASE.measurementId,
};



@NgModule({
  declarations: [
    MyApp,
    HomePage,
    TabsPage,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    IonicImageViewerModule,
    IonicSelectableModule,
    NgxSkeletonLoaderModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      iconMode: 'ios',
      modalEnter: 'modal-none',
      modalLeave: 'modal-none',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition',
    }),
    AngularFireModule.initializeApp(firebaseConfig, FIREBASE_APP_NAME),
    AngularFireDatabaseModule,
    Ng2GoogleChartsModule,
    ComponentsModule,
    LoginPageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (LanguageLoader),
        deps: [HttpClient]
      }
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    TabsPage,
    LoginPage,
  ],
  providers: [
    { provide: FirebaseAppConfigToken, useValue: firebaseConfig },
    { provide: FirebaseAppName, useValue: FIREBASE_APP_NAME },
    StatusBar,
    SplashScreen,
    ConfigApp,
    ToastService,
    ServerService,
    ActivityPickerService,
    AppVersion,
    Network,
    InAppBrowser,
    Geolocation,
    Diagnostic,
    Transfer,
    FilePath,
    File,
    Camera,
    NgxSkeletonLoaderModule,
    OpenNativeSettings,
    AndroidPermissions,
    LocalNotifications,
    SocialSharing,
    Keyboard,
    BarcodeScanner,
    WebPushService,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
  ]
})
export class AppModule {
  constructor(config: Config) {
    config.setTransition('modal-none', ModalNoneTransition);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts